export const selectSubmissions = (state) => state.submissions;
